import { DesktopMedia } from './DesktopMedia';
import { MobileOnlyMedia } from './MobileOnlyMedia';
import { useDesktopMedia } from './useDesktopMedia';
import { useIsMediaQueries } from './useIsMediaQueries';
import { useIsMediaQuery } from './useIsMediaQuery';
import { useMobileOnlyMedia } from './useMobileOnlyMedia';
export const Media = {
  DesktopOnly: DesktopMedia,
  MobileOnly: MobileOnlyMedia,
  useDesktopMedia: useDesktopMedia,
  useMobileOnlyMedia: useMobileOnlyMedia,
  useIsMediaQuery: useIsMediaQuery,
  useIsMediaQueries: useIsMediaQueries
};